import React from 'react';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { fetchVisitTopPages } from '../../../cores/api/api-dashboard';
const LastLoginCard = ({ user }) => {
    const daysAgo = dayjs().diff(dayjs(user.last_sign_in_at), 'day');
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6 bg-white rounded-2xl p-6 shadow-md"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl text-gray-500"
    }, "\u6700\u8FD1\u30ED\u30B0\u30A4\u30F3"), /*#__PURE__*/ React.createElement("div", {
        className: "text-4xl font-bold truncate mt-1"
    }, user.email), /*#__PURE__*/ React.createElement("div", {
        className: "text-xl text-red-500 mt-3"
    }, daysAgo, "\u65E5\u524D"));
};
export default function UserActivityTopCards({ params }) {
    var _a, _b;
    const _useQuery = useQuery({
        queryKey: ['fetchVisitTopPages', 3],
        queryFn: () => fetchVisitTopPages({
            limit: 3
        }),
        suspense: true
    }), data = _useQuery.data, isLoading = _useQuery.isLoading;
    const onlineUsers = (_a = data === null || data === void 0 ? void 0 : data.data.top_user_online) !== null && _a !== void 0 ? _a : [];
    const offlineUsers = (_b = data === null || data === void 0 ? void 0 : data.data.top_user_offline) !== null && _b !== void 0 ? _b : [];
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-2 gap-10"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "font-semibold text-gray-700 mb-6 text-4xl"
    }, "TOP 3\uFF08\u5229\u7528\u3057\u306A\u3044\uFF09"), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-6"
    }, offlineUsers.map(user => /*#__PURE__*/ React.createElement(LastLoginCard, {
        key: user.id,
        user: user
    })), !isLoading && offlineUsers.length === 0 && /*#__PURE__*/ React.createElement("div", {
        className: "text-gray-400 text-lg"
    }, "\u30C7\u30FC\u30BF\u306A\u3057"))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "font-semibold text-gray-700 mb-6 text-4xl"
    }, "TOP 3\uFF08\u5229\u7528\uFF09"), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-6"
    }, onlineUsers.map(user => /*#__PURE__*/ React.createElement(LastLoginCard, {
        key: user.id,
        user: user
    })), !isLoading && onlineUsers.length === 0 && /*#__PURE__*/ React.createElement("div", {
        className: "text-gray-400 text-lg"
    }, "\u30C7\u30FC\u30BF\u306A\u3057"))));
}
